export default {
    gainsBoro: '#D3D3D3',
    greenCredit: '#3c763d',
    greenContinue: '#4daf59',
    greenCheck: 'green',
    greyEmpress: '#737373',
    lightGrey: '#CCCCCC',
    lightBorderGrey: '#e5e5e5',
    whiteSmoke: '#EDEDED',
    blueCurious: '#428BCA',
    blueAstral: '#3071A9',
    blueEndeavour: '#27489E',
    blueNavy: '#3685C7',
    blueTropaz: '#30547D',
    redDebit: '#a94442',
    redRemove: '#db4747',
    redDanger: '#dc3545',
    solitude: '#E6E8EB',
    charcoal: '#444444',
    blackGrey: '#474747',
    dark: '#343a40',
    grey: '#495057',
    whiteBlack: '#ced4da',
    white: '#FFFFFF',
    black: '#000000',
    greyLight: '#999999',
    yellowInfo: '#F0AD4E',
    grayLight: '#f5f5f5',
    primaryText: '#ffffff',
    primaryButtonText: '#443D39',
    primaryBackground: '#235390',
    secondaryBackground: '#404040',
};
